import { atom, useRecoilState_TRANSITION_SUPPORT_UNSTABLE } from 'recoil';

export interface TranslatedUrlState {
  nl?: string;
  fr?: string;
  en?: string;
  de?: string;
}

export const translatedUrlState = atom<TranslatedUrlState>({
  key: 'translatedUrlState',
  default: {
    nl: undefined,
    fr: undefined,
    en: undefined,
    de: undefined,
  },
});

export const useTranslatedUrlState = () => {
  const [state, setState] = useRecoilState_TRANSITION_SUPPORT_UNSTABLE(translatedUrlState);

  return { ...state, setState };
};
